/* eslint-disable react-hooks/exhaustive-deps */
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import {
  Box,
  Grid,
  ImageList,
  ImageListItem,
  Box as MuiBox,
  Button as MuiButton,
  Typography,
  styled,
} from '@mui/material';
import { ElementType, useEffect } from 'react';

type Carousel = {
  img: string;
  text: string;
};

const StyledBlackButton: ElementType = styled(MuiButton)(({ theme }) => ({
  width: '200px',
  [theme.breakpoints.up('sm')]: {
    width: '400px',
  },
  [theme.breakpoints.up('lg')]: {
    width: '200px',
  },
}));

export const ComplianceCard = ({
  bgColor,
  onClick,
  icon,
  title,
  mainText,
  carousel,
  linkText,
  fullWidth,
  blackButton,
  center,
  ff_ren1520_compliancewelcome_newdesign,
}: any) => {
  useEffect(() => {
    if (!carousel) {
      return;
    }

    const element = document.getElementById('carouselItem__1');

    const centerCarousel = () => {
      if (element) {
        if (element?.parentElement?.parentElement) {
          const el = element.parentElement.parentElement;
          el.scrollLeft = (el.scrollWidth - el.clientWidth) / 2;
        }
      }
    };

    window.addEventListener('resize', centerCarousel);
    return () => {
      window.removeEventListener('resize', centerCarousel);
    };
  }, []);

  return (
    <Grid
      item
      xs={12}
      md={fullWidth ? 12 : 5}
      padding={3}
      margin={1}
      bgcolor={bgColor}
      onClick={onClick}
      sx={{ cursor: linkText && 'pointer' }}
      textAlign={center ? 'center' : 'left'}
      borderRadius={1}
      {...(!ff_ren1520_compliancewelcome_newdesign && { position: 'relative' })}
    >
      <Grid container spacing={3} direction="column">
        {icon && (
          <Grid item>
            <img src={icon} alt="" height={50} />
          </Grid>
        )}
        {title && (
          <Grid item>
            <Typography variant="h5">{title}</Typography>
          </Grid>
        )}
        {mainText && (
          <Grid
            item
            mt="sm"
            display={carousel ? { xs: 'block', sm: 'none' } : {}}
          >
            <Typography variant="body1">{mainText}</Typography>
          </Grid>
        )}
        {linkText && !carousel && (
          <Grid item paddingBottom={blackButton ? 0 : 4}>
            <MuiBox>
              {blackButton ? (
                <StyledBlackButton variant="contained">
                  {linkText}
                </StyledBlackButton>
              ) : (
                <MuiButton sx={{ position: 'absolute', bottom: 10 }}>
                  <Typography variant="button">{linkText}</Typography>
                  <ArrowRightAltIcon />
                </MuiButton>
              )}
            </MuiBox>
          </Grid>
        )}
        {carousel && (
          <Grid
            item
            display="flex"
            flexDirection={{ sm: 'column-reverse', lg: 'column' }}
            justifyContent="center"
            alignItems="center"
          >
            <Box height="340px" display={{ xs: 'none', sm: 'block' }}>
              <Box
                // className="invisibleScrollbar"
                position={{ sm: 'absolute', lg: 'relative' }}
                width={{ sm: '100vw', lg: 'auto' }}
                height="320px"
                left="0"
                sx={{
                  overflowX: 'auto',
                  overflowY: 'hidden',
                }}
              >
                <ImageList
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: { sm: '1160px', lg: 'auto' },
                    paddingLeft: { sm: '44px', lg: '0px' },
                    overflow: 'hidden',
                  }}
                >
                  {carousel.map((item: Carousel, index: number) => (
                    <ImageListItem
                      sx={{ marginX: '10px', borderRadius: '20px' }}
                      id={`carouselItem__${index}`}
                    >
                      <Box
                        component="img"
                        sx={{
                          width: { sm: '350px', lg: '25vw' },
                          maxWidth: '350px',
                          maxHeight: '250px',
                          borderRadius: '20px 20px 0px 0px',
                        }}
                        src={item.img}
                        alt={item.text}
                      />
                      <Box
                        bgcolor="white"
                        padding={2}
                        borderRadius="0px 0px 20px 20px"
                        textAlign="left"
                        width="auto"
                      >
                        {item.text.split('<br>').map((elt, idx) => (
                          <div key={idx}>
                            {elt}
                            <br />
                          </div>
                        ))}
                      </Box>
                    </ImageListItem>
                  ))}
                </ImageList>
              </Box>
            </Box>
            <StyledBlackButton variant="contained">
              {linkText}
            </StyledBlackButton>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
